import { Statuses, SKIP_PATHS } from 'lib/constants/signUp';

export const PICK_MEALS_DEFAULT_WEEKLY_MEALS = 8;

export const buildPaymentParams = (primaryUser, fallbackUser, firstDeliveryDate) => ({
  paymentMethodId: 'pm_card_visa',
  vendor: 'stripe',
  termsChecked: true,
  applePayEmail: '',
  paypalEmail: '',
  fullName: primaryUser?.name || parseNameFromEmail(fallbackUser) || generateRandomName('full'),
  streetAddress:
    primaryUser?.streetAddress ||
    primaryUser?.address?.streetAddress ||
    fallbackUser?.streetAddress ||
    fallbackUser?.address?.streetAddress ||
    generateChicagoStreetAddress(),
  apartmentNumber: '',
  city: primaryUser?.signupCity || fallbackUser?.signupCity,
  state: primaryUser?.signupState || fallbackUser?.signupState,
  zipCode: primaryUser?.signupZip || fallbackUser?.signupZip,
  phoneNumber: primaryUser?.phone || fallbackUser?.phone || generateChicagoPhoneNumber(),
  firstDeliveryDate,
  weeklyMeals: primaryUser?.weeklyMeals,
  servings: primaryUser?.servings,
});

export const getFunnelPages = isFamilyPlan => {
  const preferencesFunnelPage = {
    page: 'preferences',
    path: SKIP_PATHS.PREF_DIETARY,
    status: Statuses.DIETARY_PREFERENCES_STEP,
  };

  return [
    preferencesFunnelPage,
    ...(!isFamilyPlan
      ? [
          {
            page: 'promo',
            path: SKIP_PATHS.PROMO,
            status: Statuses.PROMO_STEP,
          },
        ]
      : []),
    {
      page: 'box people',
      path: SKIP_PATHS.BOX_PEOPLE,
      status: Statuses.BOX_PEOPLE_STEP,
    },
    { page: 'box', path: SKIP_PATHS.BOX, status: Statuses.BOX_STEP },
    { page: 'billing', path: SKIP_PATHS.BILLING, status: Statuses.BILLING_STEP },
    { page: 'thankyou', path: SKIP_PATHS.THANK_YOU, status: Statuses.THANK_YOU_STEP },
  ];
};

export const PICK_MEALS_INTRO_PAGES = [
  { page: 'preferences', path: SKIP_PATHS.PREF_DIETARY },
  { page: 'box people', path: SKIP_PATHS.BOX_PEOPLE },
  { page: 'box', path: SKIP_PATHS.BOX },
  { page: 'pick meals', path: SKIP_PATHS.PICK_MEALS },
  { page: 'billing', path: SKIP_PATHS.PICK_MEALS_BILLING },
  { page: 'thankyou', path: SKIP_PATHS.PICK_MEALS_THANK_YOU },
];

export const generateRandomString = length => {
  const characters = 'abcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const generateRandomEmail = () => {
  const domains = ['@gmail.com', '@outlook.com', '@yahoo.com'];
  const randomDomain = domains[Math.floor(Math.random() * domains.length)];

  let email = generateRandomName('emailFormat');
  let fullEmail = email + generateRandomNumbers(3) + generateRandomString(3) + randomDomain;
  return fullEmail;
};

export const generateRandomName = option => {
  const firstName = [
    'Dorothy',
    'Betty',
    'Margaret',
    'Ruth',
    'Virginia',
    'Doris',
    'Mildred',
    'Elizabeth',
    'Gladys',
    'John',
    'William',
    'James',
    'Charles',
    'Robert',
    'Joseph',
    'Frank',
    'George',
    'Edward',
    'Thomas',
    'Henry',
    'Walter',
    'Harold',
    'Paul',
    'Arthur',
    'Albert',
    'Richard',
    'Amara',
    'Jing',
    'Mohammed',
    'Carlos',
    'Svetlana',
  ];

  const lastName = [
    'Smith',
    'Johnson',
    'Williams',
    'Jones',
    'Brown',
    'Davis',
    'Miller',
    'Wilson',
    'Moore',
    'Anderson',
    'Thomas',
    'Taylor',
    'White',
    'Martin',
    'Jackson',
    'Harris',
    'Clark',
    'Rodriguez',
    'Lewis',
    'Lee',
    'Walker',
    'Patel',
    'Kim',
    'Gonzalez',
    'Almeida',
    'Kovacs',
    'Nguyen',
    'Schneider',
    'Abdullah',
    'Ono',
    'Mwangi',
  ];

  const randomFirstName = firstName[Math.floor(Math.random() * firstName.length)];
  const randomLastName = lastName[Math.floor(Math.random() * lastName.length)];

  if (option === 'full') {
    return `${randomFirstName} ${randomLastName}`;
  } else if (option === 'first') {
    return randomFirstName;
  } else if (option === 'last') {
    return randomLastName;
  } else if (option === 'emailFormat') {
    return `${randomFirstName}.${randomLastName}`;
  } else {
    return `${randomFirstName} ${randomLastName}`;
  }
};

export const generateChicagoStreetAddress = () => {
  const streetNumbers = Array.from({ length: 1000 }, (_, i) => i + 1);
  const streetNames = [
    'Michigan',
    'Wabash',
    'State',
    'Dearborn',
    'Clark',
    'Madison',
    'Monroe',
    'Adams',
    'Jackson',
    'LaSalle',
    'Washington',
    'Randolph',
    'Lake',
    'North',
    'Halsted',
    'Diversey',
    'Fullerton',
    'Belmont',
    'Addison',
    'Irving Park',
    'Lawrence',
    'Wilson',
    'Sheridan',
    'Broadway',
    'Devon',
    'Western',
    'Pulaski',
    'Cicero',
    'Ashland',
    'Damen',
    'Division',
    'North Avenue',
    'Armitage',
    'Lincoln',
  ];
  const streetTypes = ['Ave', 'Blvd', 'St', 'Dr', 'Rd', 'Ln', 'Way', 'Pl', 'Ct', 'Terrace'];

  const randomStreetNumber = streetNumbers[Math.floor(Math.random() * streetNumbers.length)];
  const randomStreetName = streetNames[Math.floor(Math.random() * streetNames.length)];
  const randomStreetType = streetTypes[Math.floor(Math.random() * streetTypes.length)];

  return `${randomStreetNumber} ${randomStreetName} ${randomStreetType}`;
};

export const generateChicagoPhoneNumber = () => {
  const areaCodes = ['312', '773', '872'];

  const randomAreaCode = areaCodes[Math.floor(Math.random() * areaCodes.length)];
  const prefix = generateRandomNumbers(3);
  const lineNumber = generateRandomNumbers(4);

  return `${randomAreaCode}-${prefix}-${lineNumber}`;
};

export const generateRandomNumbers = length => {
  let numbers = '';
  for (let i = 0; i < length; i++) {
    numbers += Math.floor(Math.random() * 10).toString();
  }
  return numbers;
};

export const parseNameFromEmail = user => {
  if (!user.email) {
    return null;
  }

  const emailLocalPart = user.email.split('@')[0];
  const nameMatch = emailLocalPart.match(/^([a-z]+)\.([a-z]+)/i);
  if (!nameMatch) {
    return null;
  }

  const firstName = nameMatch[1];
  const lastName = nameMatch[2];

  const fullName = `${capitalizeFirstLetter(firstName)} ${capitalizeFirstLetter(lastName)}`;

  return fullName;
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const generateFutureDeliveryDate = (dayOfWeek = 1, weeksAhead = 1) => {
  const today = new Date();
  let daysUntilTargetDay = (dayOfWeek + 7 - today.getDay()) % 7;

  if (daysUntilTargetDay === 0 && weeksAhead >= 1) {
    daysUntilTargetDay = 7;
  }

  daysUntilTargetDay += (weeksAhead - 1) * 7;
  const targetDate = new Date(today);
  targetDate.setDate(today.getDate() + daysUntilTargetDay);

  return targetDate.toISOString().split('T')[0];
};
